// src/ImageTimer.js

import React, { useState, useEffect } from 'react';

// Helper function to format time
const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const ImageTimer = ({ expirationTime }) => {
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    // Function to calculate remaining time
    const calculateTimeLeft = () => {
      const now = Date.now();
      const secondsRemaining = Math.max(0, Math.floor((expirationTime - now) / 1000));
      return secondsRemaining;
    };

    // Set the initial time left
    setTimeLeft(calculateTimeLeft());

    // Set up an interval to update the time left every second
    const timer = setInterval(() => {
      const remaining = calculateTimeLeft();
      setTimeLeft(remaining);

      // Clear interval when timer reaches 0
      if (remaining <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    // Clean up the interval when the component unmounts or expirationTime changes
    return () => clearInterval(timer);
  }, [expirationTime]); // Only re-run this effect if the expirationTime prop changes

  const isExpired = timeLeft <= 0;

  return (
    <div className={`absolute top-2 right-2 px-2 py-1 rounded-md text-xs font-bold ${
      isExpired ? 'bg-red-500 text-white' : 'bg-yellow-500 text-black'
    }`}>
      {isExpired ? 'EXPIRED' : formatTime(timeLeft)}
    </div>
  );
};

export default React.memo(ImageTimer); // Use React.memo for extra performance